
import React from 'react';
import { Moon } from 'lucide-react';
import { Button } from './ui/button';
import { useTheme } from 'next-themes';

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  return (
    <Button 
      variant="ghost" 
      size="icon" 
      onClick={toggleTheme}
      className="w-10 h-10"
      aria-label="Toggle theme"
    >
      <Moon className="h-5 w-5" />
    </Button>
  );
};

export default ThemeToggle;
